import React, { useEffect, useState } from 'react';
import Button from 'components/shared/Button';
import i18n from 'i18n';

const LanguageSwitcher = () => {
  const [lang, setLang] = useState<string>(i18n.language);

  // При монтировании восстанавливаем язык
  useEffect(() => {
    const savedLang = localStorage.getItem('lang');
    if (savedLang && savedLang !== i18n.language) {
      i18n.changeLanguage(savedLang);
      setLang(savedLang);
    }
    document.documentElement.id = savedLang === 'ar' ? 'html-arabic' : '';

        document.documentElement.classList.toggle('arabic-font', savedLang === 'ar');
    document.dir = savedLang === 'ar' ? 'rtl' : 'ltr';
  }, []);

  const toggleLanguage = () => {
    const newLang = i18n.language === 'ar' ? 'en' : 'ar';
    i18n.changeLanguage(newLang);
    localStorage.setItem('lang', newLang);
    setLang(newLang);
    document.dir = newLang === 'ar' ? 'rtl' : 'ltr';
  };

  return (
    <Button onClick={toggleLanguage} darkGreen style={{width:"100%"}}>
      {lang === 'ar' ? 'Switch to English' : 'التبديل إلى العربية'}
    </Button>
  );
};

export default LanguageSwitcher;
